<template lang="pug">
  transition(
    name="transition-fade"
    :mode="mode"
    :appear="appear"
  )
    slot
</template>

<script>
export default {
  name: 'transition-fade',

  props: {
    mode: {
      type: String,
      default: '',
    },

    appear: {},

    endFast: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style>
.transition-fade-enter-active,
.transition-fade-leave-active {
  transition: opacity .3s;
}

.transition-fade-enter,
.transition-fade-leave-to {
  opacity: 0;
}

.transition-fade-enter-to,
.transition-fade-leave {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// Fade.vue?4713bc19